import slmAxiosClient from './slmAxiosClient';
import { FAVORITE_CANDIDATE } from './URLS';

export async function removeFromFavoritesById(candidateId) {
  return slmAxiosClient.delete(`${FAVORITE_CANDIDATE}/${candidateId}`);
}

export async function addToFavoritesById(candidateId) {
  return slmAxiosClient.post(FAVORITE_CANDIDATE, {
    candidateId
  });
}

export async function handleFavoritesClick(isFavorited, candidate) {
  if (!isFavorited) {
    return addToFavoritesById(candidate.candidateId);
  }
  return removeFromFavoritesById(candidate.candidateId);
}

export async function fetchFavorites(page = 1, sort = {}) {
  const sortQuery = sort.by && sort.order ? `&sortBy=${sort.by}&sortOrder=${sort.order}` : '';
  const response = await slmAxiosClient.get(`${FAVORITE_CANDIDATE}?page=${page}${sortQuery}`);

  return response.data;
}
